import React, { useState } from 'react';
import { ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { getEmailValue } from 'utils/getEmailValue';
import CopyTextIconButton from 'components/CopyTextIconButton';

interface MerchantContactInfoListProps {
  items?: string[] | null;
  label: string;
  isCollapsed?: boolean;
  renderer?: (val: string) => React.ReactNode;
}

export const MerchantContactInfoList: React.FC<MerchantContactInfoListProps> = ({
  items,
  label,
  isCollapsed = false,
  renderer
}) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  if (!Array.isArray(items) || items.length === 0) return null;

  const filtered = items.filter(item => item?.trim() !== '');
  if (filtered.length === 0) return null;

  const isEmail = label === 'Email';

  return (
    <ListItem alignItems="center" disableGutters sx={{ m: 0 }}>
      <ListItemIcon
        sx={{ minWidth: 32, mr: 1, display: 'flex', justifyContent: 'center' }}
      >
        {isEmail ? (
          <MailOutlined style={{ fontSize: 12, color: '#706CE6' }} />
        ) : (
          <PhoneOutlined style={{ fontSize: 12, color: '#706CE6' }} />
        )}
      </ListItemIcon>

      {!isCollapsed && (
        <ListItemText
          primary={<Typography color="secondary">{isEmail ? 'Email' : 'Phone'}</Typography>}
        />
      )}

      <Stack flex={1}>
        {filtered.map((val, index) => (
          <Stack
            key={index}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={0.5}
            sx={{ height: 22 }}
            width="100%"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <Typography
              align={isCollapsed ? 'left' : 'right'}
              noWrap
              sx={{
                fontSize: 12,
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                '@media (min-width: 1280px) and (max-width: 1700px)': { maxWidth: '110px' },
                '@media (min-width: 1700px) and (max-width: 1950px)': { maxWidth: '150px' }
              }}
            >
              {getEmailValue(val, renderer)}
            </Typography>
            {hoveredIndex === index && (
              <CopyTextIconButton textToCopy={val} dispatchText={label} />
            )}
          </Stack>
        ))}
      </Stack>
    </ListItem>
  );
};